// Pending user data for identification after PostHog loads
let pendingIdentify = null;

/**
 * Identify user in PostHog. If PostHog hasn't loaded yet,
 * stores the data and will identify when PostHog becomes available.
 */
export function identifyUser(userId, properties = {}) {
  const setOnce = { first_seen_at: new Date().toISOString() };
  if (window.posthog) {
    window.posthog.identify(userId, properties, setOnce);
    pendingIdentify = null;
  } else {
    // Store for later - PostHog will call flushPendingIdentify when ready
    pendingIdentify = { userId, properties, setOnce };
  }
}

/**
 * Called by main.jsx after PostHog finishes loading.
 * Flushes any pending identify call.
 */
export function flushPendingIdentify() {
  if (pendingIdentify && window.posthog) {
    window.posthog.identify(pendingIdentify.userId, pendingIdentify.properties, pendingIdentify.setOnce);
    pendingIdentify = null;
  }
}

/**
 * Reset PostHog identity (for logout).
 */
export function resetIdentity() {
  pendingIdentify = null;
  if (window.posthog) {
    window.posthog.reset();
  }
}
